



















import { defineComponent, watch } from '@vue/composition-api';
import { usePagination } from '@/bundles/BaseTable/composables/usePagination';
import { useBadge } from '@/bundles/Badge/composables/useBadge';
import { IGetBadgeListDto } from '@/bundles/Badge/dto';
import { IBadge } from '@/bundles/Badge/interfaces';

import BadgesListTable from '@/bundles/Badge/components/BadgesListTable.vue';

export default defineComponent({
  name: 'BadgesList',

  components: {
    BadgesListTable,
  },

  setup: function () {
    const { tableOptions, pageOffset, optionsChangeEventHandler } = usePagination();
    const { badges, listLoading, total, fetch } = useBadge();

    async function fetchWrapper () {
      const wrapper = document.querySelector('.base-table-wrapper .v-data-table__wrapper')
      if (wrapper) {
        wrapper.scrollTop = 0
      }
      const params: IGetBadgeListDto = {
        skip: pageOffset.value,
        take: tableOptions.value.itemsPerPage,
      };
      await fetch(params);
    }
    watch(() => tableOptions, () => fetchWrapper(), { deep: true, immediate: true });

    function refreshBadgeInfo (badge: IBadge) {
      badges.value = badges.value.map((item) => {
        if (item.id === badge.id) {
          return badge;
        }
        return item;
      });
    }

    return {
      tableOptions,
      total,
      badges,
      listLoading,
      optionsChangeEventHandler,
      refreshBadgeInfo,
    };
  }
});
